import cx from 'classnames';
import React from 'react';

import { SimpleCallback } from '../../typings';
import { ButtonProps } from '../button/button';

import { LessonBannerViewBadge, LESSON_BANNER_VIEW_BADGE_THEME } from './__badge/lesson-banner-view__badge';
import { LessonBannerViewButton } from './__button/lesson-banner-view__button';
import { LessonBannerViewContent } from './__content/lesson-banner-view__content';
import { LessonBannerViewDescription } from './__description/lesson-banner-view__description';
import { LessonBannerViewHeader } from './__header/lesson-banner-view__header';
import { LessonBannerImageContainer } from './__image-container/lesson-banner-view__image-container';
import { LessonBannerViewImage } from './__image/lesson-banner-view__image';
import { LessonBannerViewInfo } from './__info/lesson-banner-view__info';

import './lesson-banner-view.scss';

interface Props {
    badgeText: string;
    badgeTheme?: LESSON_BANNER_VIEW_BADGE_THEME;
    buttonTextId: string;
    buttonProps?: ButtonProps;
    descriptionText: string | null;
    imageSrc: string;
    headerText: string;
    infoText: string;
    mix?: string;
    onClick?: SimpleCallback;
}

export const LessonBannerView = (props: Props) => {
    const {
        badgeText,
        badgeTheme,
        buttonProps,
        buttonTextId,
        descriptionText,
        imageSrc,
        headerText,
        infoText,
        mix,
        onClick,
    } = props;

    return (
        <div className={cx('lesson-banner-view', mix)} onClick={onClick}>
            <LessonBannerViewContent>
                <LessonBannerViewInfo text={infoText} />
                <LessonBannerViewHeader text={headerText} />
                {descriptionText && <LessonBannerViewDescription text={descriptionText} />}
                <LessonBannerViewButton
                    mix="qa_spec-course-button_status-participate"
                    textId={buttonTextId}
                    {...buttonProps}
                />
            </LessonBannerViewContent>
            <LessonBannerImageContainer>
                <LessonBannerViewBadge text={badgeText} theme={badgeTheme} />
                <LessonBannerViewImage src={imageSrc} />
            </LessonBannerImageContainer>
        </div>
    );
};

export { LESSON_BANNER_VIEW_BADGE_THEME };
